<template>
  <v-container fluid>
    <v-progress-linear v-if="$vars.loading" indeterminate class="primary--text loader"></v-progress-linear>
    <v-row no-gutters="">
      <v-col cols="12" class="pa-4">
        <div class="title">AH-Zirkel {{ zirkel }}</div>
        <v-chip label small class="mr-2" v-for="(item, index) in berechtigt" :key="index">
          {{ $filters.user(item, bbrbbr) }}
        </v-chip>
      </v-col>
      <v-col cols="4" class="pa-2">
        <v-card outlined class="rounded-lg">
          <v-card-title>Zirkel-Mitglieder ({{ mitglieder.length }})</v-card-title>
          <v-simple-table dense fixed-header height="450px">
            <thead>
              <tr>
                <th>Vorname</th>
                <th>Nachname</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="mitglied in mitglieder"
                :key="mitglied.id"
                @dblclick="(bbr = mitglied) && (showKontakt = true)"
              >
                <td>{{ mitglied.nachname }}</td>
                <td>{{ mitglied.vorname }}</td>
                <td width="20px">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon v-on="on" @click="(bbr = mitglied) && (showRemoveKontakt = true)"
                        ><v-icon>person_remove</v-icon></v-btn
                      >
                    </template>
                    <span>Bbr aus Zirkel entfernen</span>
                  </v-tooltip>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
          <v-card-actions class="hidden-xs-only">
            <v-spacer></v-spacer>
            <v-btn text class="primary--text" @click="showAddKontakt = true">Bundesbruder hinzufügen</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="4" class="pa-2">
        <veranstaltungenListe :kalender="'AH-Zirkel ' + zirkel" :hideImage="true" anzahl="15"></veranstaltungenListe>
      </v-col>
      <v-col cols="4" class="pa-2">
        <v-card outlined class="rounded-lg">
          <v-card-title class="justify-space-between">
            Gesendete Mails
            <v-btn small icon @click="showNeueMail = true"><v-icon>add</v-icon></v-btn>
          </v-card-title>
          <v-list class="py-0" dense>
            <v-subheader v-if="nachrichten.length === 0" class="justify-center">
              Keine Rundmails versendet.
            </v-subheader>
            <span v-for="(item, index) in nachrichten" :key="index">
              <v-list-item @click="(nachricht = item) && (showMail = true)">
                <v-list-item-action v-if="item.status === 'Error' && item.status">
                  <v-icon color="red">warning</v-icon>
                </v-list-item-action>
                <v-list-item-action v-if="item.status === 'Entwurf' && item.status">
                  <v-btn icon loading disabled text></v-btn>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-bold">
                    <span v-if="item.absender.position">{{ item.absender.position }}</span>
                    <span v-if="item.absender.name">{{ item.absender.name }}</span>
                    <span v-if="item.von">{{ $filters.user(item.von, bbrbbr) }}</span>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ item.message.subject }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action class="text-right">
                  {{ $filters.date(item.datum, "DD.MM.YYYY") }}<br />
                  {{ $filters.date(item.datum, "hh:mm") }} Uhr
                </v-list-item-action>
              </v-list-item>
              <v-divider v-if="index + 1 !== nachrichten.length"></v-divider>
            </span>
          </v-list>
          <v-card-actions class="hidden-xs-only">
            <v-spacer></v-spacer>
            <v-btn to="./mail" text class="primary--text">Alle Mails</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <dialogKontakt :visible.sync="showKontakt" :bbr="bbr" @close="showKontakt = false"></dialogKontakt>
    <dialogMail :visible.sync="showMail" :nachricht="nachricht" @close="showMail = false"></dialogMail>
    <dialogMailNeu :visible.sync="showNeueMail" @close="showNeueMail = false"></dialogMailNeu>
    <dialogDelete
      :visible.sync="showRemoveKontakt"
      title="Bbr aus Zirkel entfernen"
      :message="'Willst du Bbr ' + bbr.nachname + ' wirklich aus dem Zirkel entfernen?'"
      abbrechen="Abbrechen"
      weiter="Entfernen"
      @closeTrue="removeBbrFromZirkel()"
      @closeFalse="showRemoveKontakt = false"
    >
    </dialogDelete>
    <v-dialog v-model="showAddKontakt" width="50%" :fullscreen="$vuetify.breakpoint.smAndDown" persistent scrollable>
      <v-card>
        <v-card-title> Bbr dem Zirkel hinzufügen </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-autocomplete :items="bbrbbrselect" v-model="bbr" dense outlined hide-details class="mt-4"></v-autocomplete>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn @click="showAddKontakt = false" text>Abbrechen</v-btn>
          <v-spacer></v-spacer>
          <v-btn class="primary" @click="addBbrToZirkel()">hinzufügen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  export default {
    props: ["zirkel", "berechtigt"],
    data() {
      return {
        showNeueMail: false,
        loading: false,
        bbr: {},
        showKontakt: false,
        showAddKontakt: false,
        showRemoveKontakt: false,
        showMail: false,
        nachricht: {
          an: [],
          message: {},
          absender: {},
        },
      };
    },
    computed: {
      bbrbbr() {
        return this.$store.state.bbrbbr.bbrbbr;
      },
      currentBbr() {
        return this.$getCurrentBbr();
      },
      bbrbbrselect() {
        let bbrbbrselect = [];
        this.$store.getters["bbrbbr/nurBbrbbr"].forEach((bbr) => {
          bbrbbrselect.push({
            value: bbr,
            text: bbr.nachname + ", " + bbr.vorname,
          });
        });
        return bbrbbrselect;
      },
      mitglieder() {
        return this.bbrbbr.filter((bbr) => bbr.zirkel === this.zirkel);
      },
      veranstaltungen() {
        return this.$store.state.veranstaltungen.veranstaltungen.filter(
          (event) => event.kalender === "AH-Zirkel " + this.zirkel
        );
      },
      nachrichten() {
        if (this.$store.state.mails.loaded === false) {
          this.$store.dispatch("mails/loadMails");
        }
        return this.$store.getters["mails/gesendeteMails"](this.currentBbr).slice(0, 6);
      },
    },
    methods: {
      removeBbrFromZirkel() {
        this.bbr.zirkel = "";
        this.$store.dispatch("bbrbbr/updateBbrData", this.bbr);
        this.showRemoveKontakt = false;
      },
      addBbrToZirkel() {
        this.bbr.zirkel = this.zirkel;
        this.$store.dispatch("bbrbbr/updateBbrData", this.bbr);
        this.showAddKontakt = false;
      },
    },
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// zirkel.vue?0039f0e4